import convert from 'color-convert';

export const getColorContrast = (color: string) => {
    const rgb = convert.hex.rgb(color);
    const luminance = 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
    return luminance < 140 ? '#fff' : '#000';
  };
  